import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/**
 * Keeps the trailing slashes the old WordPress site was indexed under.
 *
 * Angular would otherwise treat `/faq/` as a different (unmatched) URL from
 * `/faq`. Parsing strips the slash so both resolve to the same route, and
 * serialising puts it back so links, the address bar and the canonical tag all
 * show the exact address search engines already know.
 */
export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    const [, path = '', suffix = ''] = /^([^?#]*)(.*)$/.exec(url) ?? [];
    const trimmed = path.replace(/\/+$/, '');

    return super.parse((trimmed === '' ? '/' : trimmed) + suffix);
  }

  override serialize(tree: UrlTree): string {
    const url = super.serialize(tree);
    const [, path = '', suffix = ''] = /^([^?#]*)(.*)$/.exec(url) ?? [];

    if (path === '' || path === '/' || path.endsWith('/')) {
      return url;
    }

    return `${path}/${suffix}`;
  }
}
